module.exports = __webpack_public_path__ + "static/media/PrettyLittleThing-logo.ca2ffcb2.jpg";